import { render, staticRenderFns } from "./echartData.vue?vue&type=template&id=83281492&scoped=true"
import script from "./echartData.vue?vue&type=script&lang=js"
export * from "./echartData.vue?vue&type=script&lang=js"
import style0 from "./echartData.vue?vue&type=style&index=0&id=83281492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83281492",
  null
  
)

export default component.exports